var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "MlListpopup",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          staticStyle: {
            "max-width": "780px",
            position: "fixed",
            "margin-left": "-390px",
            left: "50%",
          },
          attrs: { role: "document", id: "MlListpopupContent" },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
              staticStyle: {
                "max-height": "85vh",
                "overflow-y": "auto",
                "min-height": "0",
              },
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "btn-sticky-hold",
                  staticStyle: { top: "calc(100% - 50px)" },
                  attrs: { id: "sticky" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 text-right sticky-details" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "primary-btn pull-right",
                            attrs: { type: "button" },
                            on: { click: _vm.SaveMLSummary },
                          },
                          [_vm._v("Update Summary")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "secondary-btn mr-3 pull-right",
                            attrs: { type: "button" },
                            on: { click: _vm.ClearMLPopUp },
                          },
                          [_vm._v("Clear")]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "modal-body mt-0 pt-0 pb-5" }, [
                _c("div", { staticClass: "col-12 pb-5" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      { staticClass: "col-6 pb-3" },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Symptoms"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.symptoms_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new symptom",
                            placeholder: "Select Symptoms",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "symptom")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "symptom")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "symptoms"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_symptoms_list,
                            callback: function ($$v) {
                              _vm.selected_symptoms_list = $$v
                            },
                            expression: "selected_symptoms_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pb-3",
                        attrs: { id: "Comorbidityhold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Comorbidity"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.comorbidities_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new comorbidity",
                            placeholder: "Select Comorbidity",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "comorbidity")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "comorbidity")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "comorbidity"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_comorbidities_list,
                            callback: function ($$v) {
                              _vm.selected_comorbidities_list = $$v
                            },
                            expression: "selected_comorbidities_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pb-3",
                        attrs: { id: "Diagnosishold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Diagnosis"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.diagnosis_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new diagnosis",
                            placeholder: "Select Diagnosis",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "diagnosis")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "diagnosis")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "diagnosis"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_diagnosis_list,
                            callback: function ($$v) {
                              _vm.selected_diagnosis_list = $$v
                            },
                            expression: "selected_diagnosis_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pb-3",
                        attrs: { id: "Radiologyhold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Radiology"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.radiology_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new radiology",
                            placeholder: "Select Radiology",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "radiology")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "radiology")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "radiology"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_radiology_list,
                            callback: function ($$v) {
                              _vm.selected_radiology_list = $$v
                            },
                            expression: "selected_radiology_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pb-3",
                        attrs: { id: "Investigationshold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Investigations"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.investigation_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new investigation",
                            placeholder: "Select Investigation",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "investigation")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "investigation")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "investigation"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_investigation_list,
                            callback: function ($$v) {
                              _vm.selected_investigation_list = $$v
                            },
                            expression: "selected_investigation_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pb-3",
                        attrs: { id: "SupportiveTreatmenthold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Supportive Treatment"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.supportive_treatment_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder":
                              "Add this as new supportive treatment",
                            placeholder: "Select Supportive Treatment",
                            "close-on-select": false,
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword(
                                $event,
                                "supportive_treatment"
                              )
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword(
                                $event,
                                "supportive_treatment"
                              )
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "supportive_treatment"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_supportive_treatment_list,
                            callback: function ($$v) {
                              _vm.selected_supportive_treatment_list = $$v
                            },
                            expression: "selected_supportive_treatment_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-10 pb-3",
                        attrs: { id: "Prescriptionhold" },
                      },
                      [
                        _c("p", { staticClass: "mb-2 font-weight-500" }, [
                          _vm._v("Prescription"),
                        ]),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.prescription_list,
                            multiple: "",
                            taggable: true,
                            "tag-placeholder": "Add this as new prescription",
                            "close-on-select": false,
                            placeholder: "Select Prescription",
                          },
                          on: {
                            tag: function ($event) {
                              return _vm.addKeyword($event, "prescription")
                            },
                            remove: function ($event) {
                              return _vm.removeKeyword($event, "prescription")
                            },
                            input: function ($event) {
                              return _vm.FilterBySelectedItem(
                                $event,
                                "prescription"
                              )
                            },
                          },
                          model: {
                            value: _vm.selected_prescription_list,
                            callback: function ($$v) {
                              _vm.selected_prescription_list = $$v
                            },
                            expression: "selected_prescription_list",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-2 " }, [
                      _c(
                        "a",
                        {
                          staticClass: "add-prescription",
                          attrs: {
                            href: "javascript:void(0);",
                            title: "Add Prescription",
                            "data-toggle": "modal",
                            "data-target": "#myModal1",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.openprescriptionpopup(true)
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                position: "relative",
                                top: "6px",
                                "font-size": "20px",
                              },
                            },
                            [_vm._v("add")]
                          ),
                        ]
                      ),
                    ]),
                    _c("div"),
                    _c("div", { staticClass: "col-12" }, [
                      _vm._m(2),
                      _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: { id: "collapseExample" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-12 pb-3",
                              attrs: { id: "cho_Sugge" },
                            },
                            [
                              !_vm.suggested_summaries_list.length == 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "max-height": "300px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-striped table-sm m-0",
                                        },
                                        [
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.suggested_summaries_list,
                                              function (summary, index) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c("td", [
                                                      _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Suggested Summary - " +
                                                              _vm._s(index + 1)
                                                          ),
                                                        ]),
                                                      ]),
                                                      _c(
                                                        "div",
                                                        _vm._l(
                                                          summary,
                                                          function (
                                                            line,
                                                            line_index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: line_index,
                                                                class: {
                                                                  "line-selected":
                                                                    _vm.isLineSelected(
                                                                      index,
                                                                      line_index
                                                                    ),
                                                                  "line-unselected":
                                                                    !_vm.isLineSelected(
                                                                      index,
                                                                      line_index
                                                                    ),
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "suggested_summary_line_" +
                                                                    index +
                                                                    "_" +
                                                                    line_index,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.UseLine(
                                                                        index,
                                                                        line_index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(line)
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("CreatePrescription", {
        ref: "createPrescriptionRef",
        attrs: { prescriptionobj: _vm.ViewPrecriptionData },
        on: {
          redirecttoprescription: _vm.openprescriptionpopup,
          closepopup: _vm.onclosepopup,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        {
          staticClass:
            "modal-title text-center pull-left w-100 d-block mt-4 pb-0 mb-2 mb-0",
        },
        [_vm._v("Machine Learning")]
      ),
      _c(
        "button",
        {
          staticClass: "close d-close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "text-info" }, [
        _vm._v(
          "Notes: Selected items will be added in to Doctor summary/notes section"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          staticClass: "suggestion_acc",
          attrs: {
            "data-toggle": "collapse",
            href: "#collapseExample",
            role: "button",
            "aria-expanded": "false",
            "aria-controls": "collapseExample",
          },
        },
        [
          _vm._v("\n  Choose From Suggestions"),
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("keyboard_arrow_down"),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }